import type { Action } from "svelte/action";

const events = [
  "change",
  /*                                              */
  "input",
];

/**
 *
 *
 *
 *
 *
 */
export const refireNonComposableNativeEvent: Action<HTMLElement, HTMLElement> = (node, host) => {
  const handleEvent = (event: Event): void => {
    if (event.composed) return;
    /*                                                        */
    const canceled = host.dispatchEvent(new event.constructor(event.type, event));
    if (canceled) event.preventDefault();
  };

  events.forEach((event) => node.addEventListener(event, handleEvent));
  return {
    destroy: () => events.forEach((event) => node.removeEventListener(event, handleEvent)),
  };
};
